<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div class="canvas-panel" :class="{ 'embedded' : embedded }">
        <v-layout right>
            <opengraph ref="opengraph" 
                    focus-canvas-on-select wheelScalable 
                    :labelEditable="true" :dragPageMovable="dragPageMovable" 
                    :enableContextmenu="false" :enableRootContextmenu="false"
                    :enableHotkeyCtrlC="false" :enableHotkeyCtrlV="false"
                    :enableHotkeyDelete="false" :enableHotkeyCtrlZ="false" 
                    :enableHotkeyCtrlD="false" :enableHotkeyCtrlG="false" 
                    :slider="true" :movable="true" :resizable="true" 
                    :selectable="true" :connectable="true" :autoSliderUpdate="true"
                    v-if="value" 
                    v-on:canvasReady="bindEvents" 
                    v-on:connectShape="onConnectShape" 
                    :imageBase="imageBase">
                <!--엘리먼트-->
                <div v-for="elementId in Object.keys(value.elements)" :key="elementId">
                    <component 
                            v-if="elementId && value.elements[elementId] != null"
                            :is="getComponentByClassName(value.elements[elementId]._type)"
                            :value.sync="value.elements[elementId]"
                            :ref="elementId"
                    ></component>
                </div>
                <!-- Relation -->
                <div v-for="relationId in Object.keys(value.relations)" :key="relationId">
                    <component 
                            v-if="relationId && value.relations[relationId] != null"
                            :is="getComponentByClassName(value.relations[relationId]._type)"
                            :value.sync="value.relations[relationId]"
                            :ref="relationId"
                    ></component>
                </div>
            </opengraph>

            <v-layout v-if="!embedded">
                <v-flex>
                    <v-row style="margin-left: 70px; margin-top: 10px">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn :disabled="checkUndo" text small right @click.native="undo()"
                                       v-on="on">
                                    <v-icon medium>mdi-undo</v-icon>
                                </v-btn>
                            </template>
                            <span>Undo</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn :disabled="checkRedo" text small right @click.native="redo()"
                                       v-on="on">
                                    <v-icon medium>mdi-redo</v-icon>
                                </v-btn>
                            </template>
                            <span>Redo</span>
                        </v-tooltip>
                    </v-row>
                </v-flex>
            </v-layout>

            <v-flex v-if="!embedded" style="justify:end; align:start;">
                <v-row justify="end" align="start" style="margin-right: 10px; margin-top:16px;">
                    <v-text-field
                            style="margin-right: 5px; max-width: 200px"
                            label="Project Name"
                            v-model="projectName"
                    ></v-text-field>

                    <text-reader 
                            :importType="'json'" 
                            @load="value = $event" 
                            style="display: inline-block;"
                            :fileName.sync="projectName"
                    ></text-reader>

                    <v-menu offset-y open-on-hover left>
                        <template v-slot:activator="{ on }">
                            <div v-if="getReadOnly">
                                <v-btn
                                        text
                                        color="primary"
                                        :disabled="disableBtn"
                                        @click="saveComposition('fork')"
                                >
                                    <v-icon>{{icon.fork}}</v-icon>
                                    FORK
                                </v-btn>
                                <v-btn
                                        :color="joinRequestedText.show ? 'primary' :'success'"
                                        :disabled="disableBtn"
                                        @click="requestInviteUser()"
                                        text
                                        style="margin-right: 5px;"
                                >
                                    <div v-if="joinRequestedText.show">
                                        <v-icon>{{icon.join}}</v-icon>
                                    </div>
                                    {{ joinRequestedText.text }}
                                </v-btn>
                            </div>
                            <div v-else>
                                <v-btn  v-if="isMineProject || isClazzModeling"
                                        color="primary" text
                                        v-on="on"
                                        :disabled="disableBtn"
                                        @click="saveComposition('save')"
                                >
                                    <v-icon>{{ icon.save }}</v-icon>
                                    SAVE
                                </v-btn>
                                <v-btn  v-else
                                        color="primary" text
                                        :disabled="disableBtn"
                                        @click="saveComposition('fork')"
                                >
                                    <v-icon>{{icon.fork}}</v-icon>
                                    FORK
                                </v-btn>
                            </div>                                
                        </template>
                        <v-list>
                            <v-list-item 
                                    v-for="(item, index) in saveItems"
                                    :key="index"
                                    @click="functionSelect(item.title, index)">
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <v-menu v-if="isMineProject && isServerModeling && !getReadOnly" 
                            offset-y 
                            open-on-hover 
                            left>
                        <template v-slot:activator="{ on }">
                            <v-btn  color="primary" text
                                    v-on="on"
                                    @click="openInviteUsers()"
                                    style="margin-right: 5px;"
                                    :disabled="!initLoad"
                            >
                                <v-icon>{{ icon.share }}</v-icon>
                                SHARE
                            </v-btn>
                        </template>
                    </v-menu>
                    
                </v-row>
            </v-flex>

            <v-card class="tools" style="top:100px; text-align: center;">
                <span class="bpmn-icon-hand-tool" 
                        v-bind:class="{ icons : !dragPageMovable, hands : dragPageMovable }"
                        _width="30"
                        _height="30" 
                        v-on:click="toggleGrip">
                    <v-tooltip md-direction="right">Hands</v-tooltip>
                </span>
                <v-tooltip right v-for="(category, categoryIndex) in elementTypes" :key="categoryIndex">
                    <template v-slot:activator="{ on }">
                        <span
                                @mouseover="changeCategory(categoryIndex)"
                                class="icons draggable"
                                align="center"
                                :_component="category[0].component"
                                :_width="category[0].width"
                                :_height="category[0].height"
                                :_description="category[0].description"
                                :_label="category[0].label"
                        >
                            <img height="30px" width="30px" :src="category[0].src" v-on="on">
                        </span>
                    </template>
                    <span>{{ category[0].label }}</span>
                </v-tooltip>
            </v-card>

            <div v-for="(category, categoryIndex) in elementTypes" :key="categoryIndex">
                <div v-if="selectedCategoryIndex == categoryIndex">
                    <v-tooltip right v-for="(item, key) in category" :key="key">
                        <template v-slot:activator="{ on }" v-if="key>0">
                            <span
                                    class="draggable"
                                    align="center"
                                    :_component="item.component"
                                    :_width="item.width"
                                    :_height="item.height"
                                    :_description="item.description"
                                    :_label="item.label"
                                    @click="item.x = 500 + Math.floor(Math.random()*200); item.y=280 + Math.floor(Math.random()*150); addElement(item)"
                                    :style="toolStyle(key, categoryIndex, category.length)"
                            >
                                <img valign="middle"
                                        style="vertical-align:middle; border: 2 solid grey; -webkit-box-shadow: 5px 5px 20px 0px rgba(0,0,0,0.75); -moz-box-shadow: 5px 5px 20px 0px rgba(0,0,0,0.40); box-shadow: 5px 5px 20px 0px rgba(0,0,0,0.40);"
                                        onmouseover="this.height=this.height*1.5;this.width=this.width*1.5;this.left=this.left-this.width*0.5;this.right=this.right-this.width*0.5;"
                                        onmouseout="this.height=this.height/1.5;this.width=this.width/1.5;this.left=this.left+this.width*0.5;this.right=this.right+this.width*0.5;"
                                        height="40px" width="40px" :src="item.src" v-on="on" border=2
                                >
                                    <v-chip v-on="on">{{ item.label }}</v-chip>
                            </span>
                        </template>
                        <v-card
                                class="mx-auto"
                                max-width="400"
                                max-height="400"
                                outlined
                        >
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="overline mb-4">{{ category[0].label }}</div>
                                    <v-list-item-title class="headline mb-1">{{ item.label }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-avatar
                                        tile
                                        size="80"
                                        color="white"
                                >
                                    <v-img :src="item.src"></v-img>
                                </v-list-item-avatar>
                            </v-list-item>
                        </v-card>
                    </v-tooltip>
                </div>
            </div>
        </v-layout>

        <model-storage-dialog
                :condition="storageCondition"
                :showDialog="showStorageDialog"
                @save="saveModel"
                @fork="forkModel"
                @backup="backupModel"
                @close="storageDialogCancel"
        ></model-storage-dialog>

        <v-dialog v-model="forkAlertDialog" max-width="290">
            <v-card>
                <v-card-title class="headline">Fork
                    <v-icon>{{icon.fork}}</v-icon>
                </v-card-title>
                <v-card-text> 권한이 없어서 수정 할 수 없습니다. Fork를 하여 사용해 주세요.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="saveComposition('fork')">Fork</v-btn>
                    <v-btn color="red darken-1" text @click.native="forkAlertDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <invite-user-dialog
                v-model="inviteLists"
                :showDialog="inviteDialog"
                :checkPublic="showPublicModel"
                @all="invitePublic"
                @apply="applyInviteUsers"
                @close="closeInviteUsers"
                @add="addInviteUser"
                @remove="removeInviteUser"
        ></invite-user-dialog>

        <modeler-image-generator ref="modeler-image-generator"></modeler-image-generator>
    </div>
</template>

<script>
    import TextReader from "@/components/yaml.vue";
    import CodeViewer from "../CodeViewer";
    import { v4 } from 'uuid';
    import Pusher from 'pusher-js';
    import ModelCanvas from '../modeling/ModelCanvas'

    var changeCase = require('change-case');
    var FileSaver = require('file-saver');
    import { saveAs } from 'file-saver';

    var JSZip = require('jszip');

    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });

    export default {
        mixins: [ModelCanvas],
        name: 'uml-class-model-canvas',
        components: {
            TextReader,
            saveAs,
            Pusher,
            CodeViewer
        },
        props: {
            aggregateRootList: Array,
        },
        data() {
            return {
                // aggregateId: null,
                
                saveItems: [
                    {title: 'Save to Server'},
                    {title: 'Download model File'},
                ],
                files: {
                    md: 'mdi-markdown',
                    txt: 'mdi-file-document-outline',
                    java: 'mdi-language-java',
                    xml: 'mdi-xml',
                    shell: 'mdi-powershell',
                    docker: 'mdi-docker',
                },
                code: '',
                active: [],
                canvas: null,
                items: [],
                enableHistoryAdd: false,
                undoing: false,
                undoed: false,
                tmpValue: [],
                noPushUndo: false,

                //undo Redo
                undoRedoArray: [],
                undoRedoIndex: 0,
                currentIndex: 0,
                undoIndex: 0,

                // imageBase: 'https://raw.githubusercontent.com/kimsanghoon1/k8s-UI/master/public/static/image/symbol/',
                imageBase: `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/`,
                userId: '',
                snackbar: false,
                color: 'error',
                mode: 'multi-line',
                timeout: 6000,
                text: '수정중입니다.',
                pusher: {},
                connectCount: 0,
                connectInfo: [],
                show: false,
                channel: {},
                members: [],
                valueTmp: {},
                pathTmp: [],
                maxWidth: 0,
                maxHeight: 0,

                // fork
                forkAlertDialog: false,

                selectedCategoryIndex: null,
                elementTypes: [
                    [ 
                        {
                            'component': 'uml-class-definition',
                            'label': 'Class',
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/entity.png`
                        },
                    ],
                    [
                        {
                            'component': 'uml-vo-class',
                            'label': 'Value',
                            'width': '100',
                            'height': '100',
                            'isVO': true,
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/class_value.png`
                        },
                        {
                            'component': 'uml-vo-class-address',
                            'label': 'Address',
                            'width': '100',
                            'height': '100',
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/class_value.png`,
                            'isVO': true,
                            'description': 'Address',
                        },
                        {
                            'component': 'uml-vo-class-photo',
                            'label': 'Photo',
                            'width': '100',
                            'height': '100',
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/class_value.png`,
                            'isVO': true,
                            'description': 'Photo'
                        },
                        {
                            'component': 'uml-vo-class-user',
                            'label': 'User',
                            'width': '100',
                            'height': '100',
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/class_value.png`,
                            'isVO': true,
                            'description': 'User'
                        },
                        {
                            'component': 'uml-vo-class-money',
                            'label': 'Money',
                            'width': '100',
                            'height': '100',
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/class_value.png`,
                            'isVO': true,
                            'description': 'Money'
                        },
                        {
                            'component': 'uml-vo-class-email',
                            'label': 'Email',
                            'width': '100',
                            'height': '100',
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/class_value.png`,
                            'isVO': true,
                            'description': 'Email'
                        },
                        {
                            'component': 'uml-vo-class-payment',
                            'label': 'Payment',
                            'width': '100',
                            'height': '100',
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/class_value.png`,
                            'isVO': true,
                            'description': 'Payment'
                        },
                        {
                            'component': 'uml-vo-class-weather',
                            'label': 'Weather',
                            'width': '100',
                            'height': '100',
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/class_value.png`,
                            'isVO': true,
                            'description': 'Weather'
                        },
                        {
                            'component': 'uml-vo-class-file',
                            'label': 'File',
                            'width': '100',
                            'height': '100',
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/class_value.png`,
                            'isVO': true,
                            'description': 'File'
                        },
                    ],
                    [
                        {
                            'component': 'enum-class-definition',
                            'label': 'Enum',
                            'width': 200,
                            'height': 100,
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/class_enum.png`
                        },
                    ],
                    [
                        {
                            'component': 'uml-exception-class',
                            'label': 'Exception',
                            'width': 200,
                            'height': 100,
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/class_exception.png`
                        },
                    ],
                    [
                        {
                            'component': 'uml-text-element',
                            'label': 'Text',
                            'width': '100',
                            'height': '100',
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/text_element.png`
                        },
                    ],
                    [
                        {
                            'component': 'uml-line-element',
                            'label': 'Line',
                            'width': '100',
                            'height': '100',
                            'src': `${ window.location.protocol + "//" + window.location.host}/static/image/symbol/edge.png`
                        },
                    ]
                ],

                // unload
                leaveSite: false,

            }
        },
        beforeDestroy: function () {
            var me = this
            // this.canvas.removeSlider()
            // this.channel.pusher.unsubscribe('presence-event');
        },
        computed: {
            definitionSet() {
                return this.inputValue(this.active)
            },
            // drawer: {
            //     get: function () {
            //         var me = this
            //         var temp = false;
            //         var tmpArray = Object.values(me.value.elements)
            //         if (tmpArray.length > 0) {
            //             tmpArray.some(function (tmp, index) {
            //                 if (tmp.drawer) {
            //                     temp = true
            //                     return;
            //                 }
            //             })
            //         }
            //         return temp;
            //     }
            // },
            id: {
                get: function () {
                    return this.projectName
                }
            },
            getReadOnly() {
                return this.readOnly
            },
            disableBtn() {
                if (this.disableModel || !this.initLoad) {
                    return true
                }
                return false
            },
        },
        created: async function () {
            var me = this

            if(me.embedded) {
                if(me.aggregateRootList.length > 0) {
                    me.addAggregateRootClass(me.aggregateRootList);
                }

                me.initLoad = true

                me.$nextTick(function () {
                    localStorage.removeItem('umlClass')
                    localStorage.removeItem('aggregateRoots')
                    localStorage.removeItem('umlClass_'+me.aggregateId)
                    localStorage.removeItem('aggregateRoots_'+me.aggregateId)
                })

            } else {
                me.canvasType = 'uml';
                me.isQueueModel = true;
                me.track();
            }
        },
        mounted: function() {
            var me = this
            this.userId = v4();

            // const channel = me.pusher.subscribe('paint');
            // // channel.bind('draw', function(data) {
            // //     // console.log(data)
            // //     me.value = data.newVal
            // // });
            // channel.bind('draw', (data) => {
            //     const {userId: id, newVal} = data;
            //     if (me.userId !== id) {
            //         let used = false;
            //         if (newVal.name != 'class-relation') {
            //             me.value['definition'].some(function (tmp, index) {
            //                 if (tmp.elementView.id == newVal.elementView.id) {
            //                     me.value['definition'] = [
            //                         ...me.value['definition'].slice(0, index),
            //                         newVal,
            //                         ...me.value['definition'].slice(index)
            //                     ]
            //                     used = true;
            //                     return;
            //                 }
            //             })
            //             if (used == false) {
            //                 me.value.definition.push(newVal)
            //             }
            //             // me.value.definition.push(newVal)
            //         } else {
            //             me.value['relation'].some(function (tmp, index) {
            //                 // // console.log(tmp, index)
            //                 if (tmp._type != 'org.uengine.uml.model.bounded') {
            //                     me.value['relation'] = [
            //                         ...me.value['relation'].slice(0, index),
            //                         element,
            //                         ...me.value['relation'].slice(index)
            //                     ]
            //                     return;
            //                 }
            //                 if (me.value['relation'].length - 1 == index) {
            //                     me.value['relation'].push(element);
            //                 }
            //             })
            //         }
            //
            //     }
            // });

            Object.values(me.value.elements).forEach(function(el, idx) {
                if(el) {
                    if(el._type.endsWith('Class') && el.isAggregateRoot && el.fieldDescriptors) {
                        me.setAggregateField(el.fieldDescriptors, el)
                    }
                }
            })

        },
        watch: {
            copyValue: {
                deep: true,
                handler: _.debounce(function (newVal, oldVal) {
                    var me = this
                    var delta = jsondiffpatch.diff(oldVal, newVal);
                    if (!me.embedded && me.initLoad && delta) {
                        me.modifiedElement(delta)
                    }
                }, 500)
            },
        },

        methods: {
            getComponent(componentName) {
                let component = null
                let parent = this.$parent
                while (parent && !component) {
                    if (parent.$options.name === componentName) {
                        component = parent
                    }
                    parent = parent.$parent
                }
                return component
            },
            unLoadEvent(event) {
                localStorage.removeItem('aggregateRoots_' + this.aggregateId)
                localStorage.removeItem('umlClass_'+this.aggregateId)
                
                if (this.leaveSite) {
                    return;
                }

                event.preventDefault();
                event.returnValue = '';
            },
            functionSelect(title) {
                var me = this
                if (title == 'Save to Server') {
                    me.saveComposition('save')
                } else if (title == 'Download model File') {
                    me.download()
                } else if (title == 'Share') {
                    me.openInviteUsers()
                }
            },
            inputValue(name) {
                // // console.log(name)
                var test = [
                    name
                ]
                return test
            },
            codeModalShow() {
                this.$modal.show('code-modal');
            },
            umlModalShow() {
                // console.log("open UML")
                this.$modal.show('uml-modal');
            },
            generateZip() {
                var me = this
                me.codeList.forEach(function (list) {
                    if (!list.file) {
                        //Array
                        // // console.log(list.children)
                        // // console.log(list.name)
                        me.reverse(list.children, list.name)
                    } else {
                        me.pathTmp.push({path: list.name, code: list.code})
                        // var blob = new Blob(["Hello, world!"], {type: "text/plain;charset=utf-8"});
                        // FileSaver.saveAs(blob, list.name);
                        // console.log(list.name)
                    }
                })

                // console.log(me.pathTmp)
                var zip = new JSZip();

                var parents = [];


                me.pathTmp.forEach(function (generateData) {
                    // if(typeof generateData == String) {
                    //     // zip.file(generateData.path,)
                    // }
                    if (generateData.path.includes('/')) {
                        parents.push(generateData.path.split('/')[0])
                    }
                    zip.file(generateData.path, generateData.code)
                })
                // zip.file("package.json", "...");
                // zip.file("lib/index.js", "...");
                // zip.file("test/index.html", "...");
                // zip.file("test/asserts/file.js", "...");
                // zip.file("test/asserts/generate.js", "...");
                parents.forEach(function (prefix) {
                    zip.folder(prefix).forEach(function (relativePath, file) {
                        // console.log("iterating over", relativePath);
                        // console.log(file)
                    });
                })

                zip.generateAsync({type: "blob"})
                    .then(function (content) {
                        // Force down of the Zip file
                        saveAs(content, "archive.zip");
                    });

            },
            reverse(item, path) {
                var me = this
                item.forEach(function (list) {
                    if (list.children) {
                        //폴더 생성하기
                        // console.log(list.name)
                        var tmpPath = path + '/' + list.name
                        // console.log(tmpPath)

                        me.reverse(list.children, tmpPath);
                    } else {
                        //파일생성하
                        // console.log(list.name)
                        if (list.code) {
                            me.pathTmp.push({path: path + '/' + list.name, code: list.code})
                            // console.log(me.pathTmp)
                        }
                        // else {
                        //     me.pathTmp.push(path+'/'+list.name+'/')
                        // }
                    }
                })
            },
            // makeFiles(List){
            //
            //
            // },
            codeModalhide() {
                this.$modal.hide('code-modal');
            },
            unselectedAll: function () {
                Object.values(this.value.elements).forEach(function (element) {
                    if(element != null) {
                        element.selected = false
                    }
                })

                Object.values(this.value.relations).forEach(function (relation) {
                    if(relation != null) {
                        relation.selected = false
                    }
                })
            },
            ajax: function (url, method, payload, successCallback) {
                var xhr = new XMLHttpRequest();
                xhr.open(method, url, true);
                // xhr.withCredentials = true;
                xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                xhr.onreadystatechange = function () {
                    if (xhr.readyState != 4 || xhr.status != 200) return;
                    successCallback(xhr.responseText);
                };
                xhr.send(JSON.stringify(payload));
            },
            connectshow: function () {
                var me = this
                if (me.show == true) {
                    me.show = false
                } else {
                    me.show = true
                }
            },
            restApiPush: function () {
                var me = this;
                me.$http.post(`${me.getProtocol()}api.${me.getTenantId()}/event/${me.projectName}`, me.value, {
                        responseType: "arraybuffer",
                        headers: {
                            'Content-Type': 'application/zip;'
                        }
                    }
                ).then(function (response) {
                    // console.log("Trying saving zip ...");
                    // console.log(response.data.length);
                    var blob = new Blob([response.data], {type: 'application/zip'});
                    // console.log(blob.size);
                    var fileName = me.projectName + ".zip";
                    saveAs(blob, fileName);
                    // console.log("saveBlob succeeded");
                })
            },
            //멀티
            syncOthers(elements) {
                var me = this
                let userId = this.userId
                let newVal = elements

                const body = {
                    newVal,
                    userId,
                };
                fetch('http://localhost:4000/paint', {
                    method: 'post',
                    body: JSON.stringify(body),
                    headers: {
                        'content-type': 'application/json',
                    },
                }).then(() => console.log("throw"));
            },
            //복사
            copy: function () {
                var me = this
                if (!me.drawer) {
                    me.tempValue = []
                    Object.values(me.value.elements).forEach(function (tmp, idx) {
                        if(tmp != null) {
                            if (tmp.selected == true) {
                                me.tempValue.push(tmp)
                            }
                        }
                    })
                    Object.values(me.value.relations).forEach(function (tmp, idx) {
                        if (tmp.selected == true) {
                            me.tempValue.push(tmp)
                        }
                    })
                    // this.syncOthers(tmp);
                }
            },
            b64toBlob: function (b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                var byteCharacters = atob(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, {type: contentType});
                return blob;
            },
            //붙여넣기
            paste: function () {
                var me = this
                if (!me.drawer) {
                    var temp = JSON.parse(JSON.stringify(me.tempValue))

                    if (me.tempValue != null) {
                        temp.forEach(function (tmp, idx) {
                            tmp.elementView.id = me.uuid();
                            tmp.elementView.x = tmp.elementView.x + 10
                            tmp.elementView.y = tmp.elementView.y + 10
                            me.value.definition.push(tmp);
                            // me.redoArray.push(tmp);
                        })
                        // this.syncOthers(tmp);
                        //초기화
                    } else {
                    }
                }
            },
            download: function () {
                var me = this;
                var text = JSON.stringify(me.value);

                var filename = this.projectName + '.json';

                var file = new File([text], filename, {
                    type: "text/json;charset=utf-8"
                });
                FileSaver.saveAs(file);
            },
            deleteBoundary(definitionArray, deleteItem) {

                //해당 바운더리 찾기
                definitionArray.forEach(function (definitionTmp, index) {
                    if (deleteItem.boundedContext == definitionTmp.inputText && definitionTmp._type == 'org.uengine.uml.model.bounded') {
                        // console.log(deleteItem.boundedContext, definitionTmp.inputText)

                        definitionTmp.dataList.forEach(function (item, idx) {
                            if (item.inputText == deleteItem.inputText && item._type == deleteItem._type) {
                                // console.log(definitionTmp.dataList[idx])
                                definitionTmp.dataList[idx] = null;

                                definitionTmp.dataList = definitionTmp.dataList.filter(n => n)
                            }
                        })
                    }
                })
            },
            deleteActivity: function () {
                var me = this
                if (!me.drawer) {
                    let selected = []

                    let definitionArray = JSON.parse(JSON.stringify(me.value.definition));
                    let relationArray = JSON.parse(JSON.stringify(me.value.relation));

                    definitionArray.forEach(function (definitionTmp, index) {
                        if (definitionTmp.selected) {
                            if (definitionTmp.boundedContext) {
                                me.deleteBoundary(definitionArray, definitionTmp);

                            }
                            selected.push(definitionTmp.elementView.id)
                            definitionArray[index] = null
                        }
                    })

                    definitionArray = definitionArray.filter(n => n)


                    selected.forEach(function (selectedTmp,idx) {
                        relationArray.forEach(function (relation, index) {
                            if (relation.to == selectedTmp || relation.from == selectedTmp) {
                                relationArray[index] = null
                            }
                        })
                    })

                    relationArray = relationArray.filter(n => n)
                    relationArray.forEach(function (relationTmp, index) {
                        if (relationTmp.selected) {
                            relationArray[index] = null
                        }
                    })
                    relationArray = relationArray.filter(n => n)

                    me.value.definition = definitionArray
                    me.value.relation = relationArray
                    // this.syncOthers();
                }
            },
            toggleGrip: function () {
                this.dragPageMovable = !this.dragPageMovable;

                if (this.dragPageMovable) {
                    this.cursorStyle = 'cursor: url("/static/image/symbol/hands.png"), auto;';
                    this.handsStyle = ' color: #ffc124;';
                } else {
                    this.cursorStyle = null;
                    this.handsStyle = null;
                }
            },
            bindEvents: function (opengraph) {
                var me = this;
                var el = me.$el;
                var canvasEl = $(opengraph.container);
                if (!canvasEl || !canvasEl.length) {
                    return;
                }
                this.canvas = opengraph.canvas;
                //아이콘 드래그 드랍 이벤트 등록
                $(el).find('.draggable').draggable({
                    start: function () {
                        canvasEl.data('DRAG_SHAPE', {
                            'component': $(this).attr('_component'),
                            'width': $(this).attr('_width'),
                            'height': $(this).attr('_height'),
                            'label': $(this).attr('_label'),
                        });
                    },
                    helper: 'clone',
                    appendTo: canvasEl
                });

                canvasEl.droppable({
                    drop: function (event, ui) {
                        var componentInfo = canvasEl.data('DRAG_SHAPE'),
                            shape, element;
                        if (componentInfo) {
                            var dropX = event.pageX - canvasEl.offset().left + canvasEl[0].scrollLeft;
                            var dropY = event.pageY - canvasEl.offset().top + canvasEl[0].scrollTop;

                            dropX = dropX / opengraph.scale;
                            dropY = dropY / opengraph.scale;

                            componentInfo = {
                                component: componentInfo.component,
                                x: dropX,
                                y: dropY,
                                width: parseInt(componentInfo.width, 10),
                                height: parseInt(componentInfo.height, 10),
                                label: componentInfo.label,
                            }
                            me.addElement(componentInfo);
                        }
                        canvasEl.removeData('DRAG_SHAPE');
                    }
                });
            },
            uuid: function () {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                        .toString(16)
                        .substring(1);
                }

                return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                    s4() + '-' + s4() + s4() + s4();
            },
            onConnectShape: function (edge, from, to) {
                var me = this;
                // // console.log(edge)
                //존재하는 릴레이션인 경우 (뷰 컴포넌트), 데이터 매핑에 의해 자동으로 from, to 가 변경되어있기 때문에 따로 로직은 필요없음.
                //=> 바뀌어야 함.
                //신규 릴레이션인 경우에는 릴레이션 생성
                var edgeElement, originalData;
                var isComponent = false;
                if (edge.shape) {
                    edgeElement = edge;
                } else {
                    isComponent = true;
                    edgeElement = edge.element;
                }

                if (edgeElement && from && to) {
                    var vertices = '[' + edgeElement.shape.geom.vertices.toString() + ']';
                    var componentInfo = {
                        component: 'uml-class-relation',
                        sourceElement: from.$parent.value,
                        targetElement: to.$parent.value,
                        vertices: vertices,
                        isFilled: true,
                        relationView: {
                            style: JSON.stringify({}),
                            value: vertices,
                        },
                        type: 'org.uengine.uml.model.Association'
                    }

                    from.$parent.value.elementView.id = from.id;
                    to.$parent.value.elementView.id = to.id;

                    if (isComponent) {
                        me.canvas.removeShape(edgeElement, true);
                        //this.removeComponentByOpenGraphComponentId(edgeElement.id);
                        //기존 컴포넌트가 있는 경우 originalData 와 함께 생성
                        this.addElement(componentInfo, null, JSON.parse(JSON.stringify(originalData)));
                    } else {
                        me.canvas.removeShape(edgeElement, true);
                        //기존 컴포넌트가 없는 경우 신규 생성
                        this.addElement(componentInfo);
                    }
                    // this.syncOthers();
                }
            },
            undoRedo: function (cmd) {
                var me = this
                if (!me.drawer) {
                    if (cmd == 'redo') {
                        if (me.undoRedoIndex < me.undoRedoArray.length - 1) {
                            me.undoRedoIndex = me.undoRedoIndex + 1
                            me.value = JSON.parse(JSON.stringify(me.undoRedoArray[me.undoRedoIndex]));
                        } else {
                            me.text = "Last element"
                            me.snackbar = true
                            me.timeout = 500
                        }
                    } else if (cmd == 'undo') {
                        if (me.undoRedoIndex > 0) {
                            me.undoRedoIndex = me.undoRedoIndex - 1
                            me.value = JSON.parse(JSON.stringify(me.undoRedoArray[me.undoRedoIndex]));
                        } else {
                            me.text = "Last Element"
                            me.snackbar = true
                            me.timeout = 500
                        }
                    }
                }

            },
            addElement: function (componentInfo, isAggRoot) {
                this.enableHistoryAdd = true;
                var me = this;
                var vueComponent = me.getComponentByName(componentInfo.component);
                var element;
                if (componentInfo.component == 'uml-class-relation') {
                    var targetMultiplicity = componentInfo.type.includes('Aggregation') ? "1..n": "1"
                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        componentInfo.sourceElement,
                        componentInfo.targetElement,
                        componentInfo.vertices,
                        componentInfo.type,
                        targetMultiplicity
                    );

                } else if(componentInfo.component == 'uml-class-group') {
                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        componentInfo.x,
                        componentInfo.y,
                        componentInfo.width,
                        componentInfo.height,
                        componentInfo.label
                    );

                } else if(componentInfo.component == 'uml-class-definition' || componentInfo.component.includes('uml-vo-class')) {    
                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        componentInfo.x,
                        componentInfo.y,
                        componentInfo.width,
                        componentInfo.height
                    );

                } else if(componentInfo.component.includes('line')) {
                    var vertices = [[componentInfo.x, componentInfo.y], [componentInfo.x + 200, componentInfo.y]]
                    vertices = JSON.stringify(vertices)

                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        vertices
                    );
                } else {
                    element = vueComponent.computed.createNew(
                        this.uuid(),
                        componentInfo.x,
                        componentInfo.y,
                        componentInfo.width,
                        componentInfo.height
                    );
                }
                
                if(!me.embedded) {
                    if (me.value == null) {
                        me.value = { 'elements': {}, 'relations': {} }
                    }
                }
                
                if(!isAggRoot) {
                    me.addElementPush(element)

                    // new UndoRedo
                    if (me.undoRedoIndex != me.currentIndex) {
                        //undoRedo 했을때
                        //삭제후
                        me.undoRedoArray.splice(me.undoRedoIndex + 1, me.currentIndex - me.undoRedoIndex);
                        me.undoRedoIndex = me.undoRedoIndex + 1
                        me.currentIndex = me.undoRedoIndex
                    } else {
                        me.undoRedoIndex = me.undoRedoIndex + 1
                    }
                    me.undoRedoArray.push(JSON.parse(JSON.stringify(me.value)));
                    me.currentIndex = me.undoRedoArray.length - 1
                }

                return element;
                // this.syncOthers(element);
            },
            getComponentByName: function (name) {
                var componentByName;
                $.each(window.Vue._components, function (i, component) {
                    if (component.name == name) {
                        // // console.log(component.default.name)
                        componentByName = component;
                    }
                });
                return componentByName;
            },
            getComponentByClassName: function (className) {
                var componentByClassName;

                $.each(window.Vue.classModelingComponents, function (i, component) {
                    if (component.default.computed && component.default.computed.className && component.default.computed.className() == className) {
                        componentByClassName = component.default;
                    }
                });
                return componentByClassName;
            },
            changeCategory(key) {
                // console.log(key)
                var me = this
                if (me.selectedCategoryIndex == key)
                    me.selectedCategoryIndex = null;
                else
                    me.selectedCategoryIndex = key
            },
            toolStyle(cardIndex, categoryIndex, cardLength) {
                var me = this
                var angle = (cardIndex - categoryIndex / 10) * 40 / (cardLength + 1) - 10;
                var angle2 = cardIndex * 10 / cardLength - 3;
                var radians = (Math.PI / 180) * angle;

                var curvedX = Math.cos(radians) * 500 - 500;
                var curvedY = Math.sin(radians) * 700 + categoryIndex * 10 + 50;

                return `left: ${100 + curvedX}px; top: ${104 + curvedY}px; text-align: center; position: absolute; transform: rotate(${angle2}deg);`;
            },
            addAggregateRootClass(aggregateRoots) {
                var me = this
                if(!aggregateRoots) {
                    return 
                }

                aggregateRoots.forEach(function(item, idx) {
                    var groupEl
                    var groupComponent = {
                        'component': 'uml-class-group',
                        'label': item.name,
                        'width': 350,
                        'height': 350,
                        'x': 350 + (idx * 400),
                        'y': 200,
                        'isCreated': false,
                    }

                    var element
                    var componentInfo = {
                        'component': 'uml-class-definition',
                        'label': item.name,
                        'width': 200,
                        'height': 100,
                        'x': 350 + (idx * 400),
                        'y': 150,
                        'isCreated': false,
                    }

                    Object.values(me.value.elements).forEach((el) => {
                        if(el) {
                            if(el._type == 'ClassGroup' && (el.aggregateRoot == item.elementView.id || el.name == item.name)) {
                                groupComponent.isCreated = true
                            }
                            if((el.parentId == item.elementView.id || el.name == item.name) && el._type != 'ClassGroup') {
                                el.name = item.name
                                el.fieldDescriptors = item.aggregateRoot.fieldDescriptors
                                el.operations = item.aggregateRoot.operations
                                el.isAggregateRoot = true
                                el.isVO = false
                                el.parentId = item.elementView.id

                                if(el.elementView.x == 350) {
                                    el.elementView.x = 350 + (idx * 400)
                                }
                                componentInfo.isCreated = true

                                if (!el.groupElement) {
                                    groupEl = me.addElement(groupComponent)
                                    groupEl.aggregateRoot = item.elementView.id
                                    el.groupElement = groupEl.elementView.id
                                } else {
                                    me.value.elements[el.groupElement].name = item.name
                                    if(me.value.elements[el.groupElement].elementView.x == 350) {
                                        me.value.elements[el.groupElement].elementView.x = 350 + (idx * 400)
                                    }
                                }
                                groupComponent.isCreated = true
                                
                                element = el;
                            }
                        }
                    })

                    if(!groupComponent.isCreated) {
                        groupEl = me.addElement(groupComponent)
                        groupEl.aggregateRoot = item.elementView.id
                        groupComponent.isCreated = true

                        if(!componentInfo.isCreated) {
                            element = me.addElement(componentInfo)
                            element.fieldDescriptors = item.aggregateRoot.fieldDescriptors
                            element.operations = item.aggregateRoot.operations
                            element.isAggregateRoot = true
                            element.isVO = false
                            element.parentId = item.elementView.id
                            element.groupElement = groupEl.elementView.id
                            element.name = item.name
                            componentInfo.isCreated = true
                        }
                    } else {
                        if(!componentInfo.isCreated) {
                            componentInfo.height = 80 + (item.aggregateRoot.fieldDescriptors.length * 20) + (item.aggregateRoot.operations.length * 20)
                            element = me.addElement(componentInfo)
                            element.fieldDescriptors = item.aggregateRoot.fieldDescriptors
                            element.operations = item.aggregateRoot.operations
                            element.isAggregateRoot = true
                            element.isVO = false
                            element.parentId = item.elementView.id
                            element.name = item.name
                        }
                    }
                    me.setAggregateField(item.aggregateRoot.fieldDescriptors, element)
                })
            },
            setAggregateField(val, root) {
                if(!root) {
                    return
                }
                var me = this
                var componentInfo = {
                    'component': 'uml-vo-class',
                    'x': root.elementView.x,
                    'y': root.elementView.y,
                    'width': '100',
                    'height': '100',
                }

                var typeList = ['Integer', 'String', 'Boolean', 'Float', 'Double', 'Long', 'Date'];
                val.forEach(function(attr) {
                    var isCreated = false
                    var _idx = -1
                    Object.values(me.value.elements).forEach(function (el, idx) {
                        if(el) {
                            if(el.name != "" && attr.className.includes(el.name) && el._type != 'ClassGroup') {
                                isCreated = true
                                _idx = idx
                            }
                        }
                    })

                    // primitvie type 이 아닌 경우
                    if(!isCreated && !typeList.includes(attr.className)) {
                        if(attr.isVO && attr.referenceClass) {
                            componentInfo.x += Math.floor(Math.random()*200)
                            componentInfo.y += Math.floor(Math.random()*150)
                            
                            var target = me.addElement(componentInfo)
                            target.name = attr.namePascalCase
                            target.namePascalCase = attr.namePascalCase
                            target.nameCamelCase = attr.nameCamelCase
                            target.isVO = true
                            target.groupElement = root.groupElement
                            target.isAggregateRoot = false
                            
                            target.referenceClass = attr.referenceClass
                            target.fieldDescriptors = [{
                                "_type": "org.uengine.uml.model.FieldDescriptor",
                                    "name": "id",
                                    "className": "Long",
                                    "isKey": false,
                                    "isVO": false,
                                    "namePascalCase": "Id",
                                    "nameCamelCase": "id",
                                    "label": "- id: Long"
                            }]
                            me.setRelations(root, target, attr.name)
                        }
                    } 
                    
                    if(isCreated && !typeList.includes(attr.className)) {
                        var target = Object.values(me.value.elements)[_idx];
                        target.groupElement = root.groupElement;
                        me.setRelations(root, target, attr.name)
                    }
                })
            },
            setRelations(source, target, relationName) {
                var me = this;
                var isNew = true;
                var vertices = [[source.elementView.x, source.elementView.y], [target.elementView.x, target.elementView.y]]
                var relationInfo = {
                    component: 'uml-class-relation',
                    sourceElement: source,
                    targetElement: target,
                    type: 'org.uengine.uml.model.Association',
                    vertices: JSON.stringify(vertices),
                };
                Object.values(me.value.relations).forEach(function(item, idx) {
                    if(item) {
                        if(item.sourceElement.elementView.id == source.elementView.id && item.targetElement.elementView.id == target.elementView.id) {
                            isNew = false;
                            item.name = relationName;
                        }
                    }
                })
                if(isNew) {
                    var relation = me.addElement(relationInfo)
                    relation.name = relationName
                }
            },
            saveAggregeteRoot() {
                var me = this
                var values = JSON.stringify(me.value)

                Object.values(me.value.elements).forEach(function (el) {
                    if(el) {
                        if(el.isAggregateRoot && el.parentId) {
                            me.$EventBus.$emit(`${el.parentId}`, values);
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .embedded {
        position: absolute;
        width: 100%;
        height: 90%;
        top: 10% !important;
        left: 0;
        right: 0;
        overflow: hidden;
    }

    .canvas-panel {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
        overflow: hidden;

        .fullcanvas {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 10%;
            left: 0;
            overflow: hidden;
        }

        .fullcanvashands {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 10%;
            left: 0;
            overflow: hidden;
            cursor: url('../../../../public/static/image/symbol/hands.png'), auto;
        }

        .tools {
            position: absolute;
            width: 48px;
            left: 20px;
            top: 20px;
            padding: 4px;
            overflow: hidden;

            .icons {
                margin-top: 5px;
                margin-bottom: 5px;
            }

            .hands {
                margin-top: 5px;
                margin-bottom: 5px;
            }
        }

        .zoom {
            position: absolute;
            width: 42px;
            right: 20px;
            bottom: 120px;

            .icons {
                font-size: 25px;
                margin-left: 10px;
                margin-top: 5px;
                margin-bottom: 5px;
            }

            .hands {
                font-size: 25px;
                margin-left: 10px;
                margin-top: 5px;
                margin-bottom: 5px;
            }
        }

        .icons {
            cursor: pointer;
            font-size: 30px;

            &:hover {
                color: #ffc124;
            }
        }

        .hands {
            cursor: pointer;
            font-size: 30px;
            color: #ffc124;
        }

        .export,
        .history,
        .import,
        .save {
            position: absolute;
            padding: 8px;

            .icons {
                font-size: 25px;
                margin-left: 10px;
            }
        }

        .import {
            left: 80px;
            bottom: 20px;
        }

        .export {
            left: 180px;
            bottom: 20px;
        }

        .history {
            left: 280px;
            bottom: 20px;
        }
    }

    /* The whole thing */
    .custom-menu {
        display: none;
        z-index: 1000;
        position: absolute;
        overflow: hidden;
        border: 1px solid #CCC;
        white-space: nowrap;
        font-family: sans-serif;
        background: #FFF;
        color: #333;
        border-radius: 5px;
        padding: 0;
    }

    /* Each of the items in the list */
    .custom-menu li {
        padding: 8px 12px;
        cursor: pointer;
        list-style-type: none;
        transition: all 0.3s ease;
        user-select: none;
    }

    .custom-menu li:hover {
        background-color: #DEF;
    }
</style>
